export default "__VITE_ASSET__DOAJs3kJ__"